'use client'

import { ErrorDataUnavailable } from '@/components/common/Error'

const VaultHeroError = () => {
  return (
    <div className="w-full" data-testid="vault-v1-hero-error">
      <ErrorDataUnavailable minHeight="338px" />
    </div>
  )
}

export default VaultHeroError
